// ============================================================
// Integración ligera con Google Ads Conversions
// ------------------------------------------------------------
// - Carga la config (AW-ID + labels) desde /api/public-config/ads
// - Inyecta el script gtag.js SOLO si hay AW-ID válido y enabled=true
// - Expone fireAdsConversion(type) para reportar conversiones a Google Ads
// - No depende de GTM: usa gtag directamente, que es lo que Google Ads acepta
// ============================================================

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

let _loadedConfig = null;
let _gtagLoading = false;

export async function loadAdsConfig() {
  if (_loadedConfig) return _loadedConfig;
  try {
    const res = await fetch(`${BACKEND_URL}/api/public-config/ads`, { credentials: "omit" });
    if (!res.ok) return null;
    const data = await res.json();
    _loadedConfig = data;
    return data;
  } catch {
    return null;
  }
}

function ensureGtag(adsId) {
  if (_gtagLoading) return;
  if (typeof window === "undefined") return;
  if (window.gtag) {
    // gtag ya cargado (puede venir de GTM o GA4); solo aseguramos config
    try {
      window.gtag("config", adsId);
    } catch {}
    return;
  }
  _gtagLoading = true;
  try {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    window.gtag("js", new Date());
    window.gtag("config", adsId);

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(adsId)}`;
    document.head.appendChild(s);
  } catch {
    // silencioso
  }
}

export async function initAdsConversion() {
  const cfg = await loadAdsConfig();
  if (!cfg || !cfg.enabled || !cfg.google_ads_id) return;
  ensureGtag(cfg.google_ads_id);
}

/**
 * Dispara una conversión de Google Ads.
 * @param {'form'|'catalog'|'whatsapp'|'phone'} type - Tipo de conversión
 * @param {object} extra - Campos extra (value, transaction_id, etc.)
 */
export async function fireAdsConversion(type, extra = {}) {
  try {
    const cfg = await loadAdsConfig();
    if (!cfg || !cfg.enabled || !cfg.google_ads_id) return;
    const label = cfg.labels?.[type];
    if (!label) return; // Sin label configurado para este tipo
    ensureGtag(cfg.google_ads_id);
    if (typeof window !== "undefined" && window.gtag) {
      const send_to = label.includes("/") ? label : `${cfg.google_ads_id}/${label}`;
      window.gtag("event", "conversion", {
        send_to,
        ...extra,
      });
    }
  } catch {
    // no-op
  }
}

export default { loadAdsConfig, initAdsConversion, fireAdsConversion };
